import Vue from 'vue';
const requireComponents = require.context('./', true, /\.vue/);
requireComponents.keys().forEach(fileName => {
const reqCom = requireComponents(fileName);
// 组件必须命名name，统一组件名
let reqComName =reqCom.name|| reqCom.default.name;
if(reqComName) {
    Vue.component(reqComName, reqCom.default || reqCom);
}
});